import { Overlay, Popover } from 'react-bootstrap';

import { TabMenu } from '@/App/tabs/TabMenu/TabMenu.tsx';

interface TabMenuOverlayProps {
  target: HTMLElement | null;
  tabId: string;
  closeMenu: () => void;
}

export function TabMenuOverlay({ closeMenu, tabId, target }: TabMenuOverlayProps) {
  return (
    <Overlay show target={target} rootClose onHide={closeMenu} placement="bottom">
      <Popover style={{ maxWidth: 'unset' }}>
        <Popover.Body>
          <TabMenu tabId={tabId} closeMenu={closeMenu} />
        </Popover.Body>
      </Popover>
    </Overlay>
  );
}
